export const IS_PRODUCTION = process.env.REACT_APP_ENV_NAME === 'PROD'
export const AMIL_CLINIC_IDS = [8678, 8867]
export const CAAPR_CLINIC_IDS = [8855, 8386]
export const MAGIC_LINK_MULTIPROFILE_TOKEN = IS_PRODUCTION
  ? 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiUFYiLCJlbnYiOiJQUkQifQ.rGRt_yj5si5G6r7o17cY8LdJWlE34LfJMXGJ3YH35KI'
  : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiUFYiLCJlbnYiOiJITUwifQ.D1TtXZ3SOJzNfhNvT_CGQXk7B2GWVvgtC-UoMFyjeV0'
